import { makeStyles } from "@material-ui/core";
import { useSelector } from "react-redux";
import UtilService from '../../../../../../../helper/service';
import { forwardRef, useImperativeHandle, useState } from "react";

const useStyles = makeStyles(() => ({
  verticalBar: {
    background: '#017AEF',
    width: 2,
    height: '100%',
    position: 'absolute',
    left: 20,
    zIndex: 7,
  },
  barIcon: {
    cursor: 'pointer',
    marginLeft: -28,
    bottom: 440,
    position: 'absolute'
  },
  time: {
    color: '#017AEF',
    fontSize: 17,
    fontFamily: 'Spartan-extrabold',
    background: '#F0F0F0',
    width: 38,
    height: 18,
    paddingTop: 2,
    marginLeft: -18,
    marginTop: 30,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
}));

const PencilMarker = forwardRef((props: any, ref) => {

  PencilMarker.displayName = 'PencilMarker'

  const { onAddNote } = props;
  const classes = useStyles();
  const { analyseStart, cliped, settings, stimulus, currentSession } = useSelector((state: any) => state.analysis);
  const { session_type } = currentSession;
  const { graphZoom } = settings;
  const start = cliped ? (cliped.start_clip - (session_type === 'ASYNC' ? 0 : analyseStart)) / Math.pow(graphZoom, 2) : 0;

  const [xPosition, setXPosition] = useState(0);
  const [yPosition, setYPosition] = useState(0);
  const [xScrollPosition, setXScrollPosition] = useState(0);
  const videoAvailable = !cliped || cliped && (cliped.start_clip - analyseStart < stimulus?.stimulus_video_length)

  useImperativeHandle(
    ref,
    () => ({
      containerScrolled(scrollAmount: any) {
        setXScrollPosition(Number(scrollAmount));
      },
      setMouseXPosition(xPos: any) {
        setXPosition(xPos);
      },
      setMouseYPosition(yPos: any) {
        setYPosition(yPos);
      }
    }),
  )

  return (
    <div
      id={'div_ver_bar'}
      className={classes.verticalBar}
      style={{ left: (xPosition + xScrollPosition), marginTop: (videoAvailable && stimulus) ? -80 : -5 }}
      onClick={() => onAddNote(xPosition + xScrollPosition, yPosition)}
    >
      <div className={classes.time}>
        {UtilService.getTimeLabel((xPosition + xScrollPosition) / 15, graphZoom, start)}
      </div>
      <img
        src={'/assets/icons/liveanalysis/blue-pencil.svg'}
        alt={'img'}
        className={classes.barIcon}
      />
    </div>

  );
});

export default PencilMarker;